import React from "react"
import { Link } from "react-router-dom"

export const MptSelectorCard = props => {
  const accessKey = `Use ${props.acceskey} key as a shortcut`
  return (
    <React.Fragment>
        <div className="selectorCard5X2" title={accessKey}>
          <Link to={props.path} className="selectorLink pointerHover">
            <img draggable="false" src={props.imgSrc} alt="xopowo selector" className="mptCardImg noContextMenu" />
            <p className="cardModel">{props.model}</p>
            <p className="cardVersion">{props.version}</p>
          </Link>
        </div>     
    </React.Fragment>  
  )
}